import { Header } from "../../types";
import EntityTable from "../../components/EntityTable/EntityTable";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState } from "react";
import EntityAddUpdateForm from "../../components/EntityAddUpdateForm/EntityAddUpdateForm";
import TextInput from "../../components/ui/Input/TextInput";
import SelectInput from "../../components/ui/Input/SelectInput";
import ThreeLineCardSkeleton from "../../components/SkeletonCards/ThreeLineCardSkeleton";
import { toast } from "react-toastify";

type User = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  status: number;
  role: string;
  role_id: string;
  skills_abhs: number;
  skills_abhs_mod2: number;
  skills_pom_straps: number;
};

const AdminUsers: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [isUpdateActive, setIsUpdateActive] = useState(false);
  
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

  const userHeaders: Header[] = [
    { label: "First name", key: "first_name" },
    { label: "Last name", key: "last_name" },
    { label: "Email", key: "email" },
    { label: "Role", key: "role" },
  ];
  // const roles = [
  //   { value: "admin", label: "Admin" },
  //   { value: "subadmin", label: "Sub Admin" },
  //   { value: "announcer", label: "Announcer" },
  //   { value: "director", label: "Director" },
  //   { value: "judge", label: "Judge" },
  //   { value: "performer", label: "Performer" },
  // ];
  // const roleIds: { [key: string]: number } = {
  //   admin: 1,
  //   subadmin: 2,
  //   director: 3,
  //   announcer: 4,
  //   judge: 5,
  //   performer: 6,
  // };

  const {
    data: users,
    setData: setUsers,
    errorContent,
    isLoading,
    fetchData,
  } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/users`,
  });

  const {
    data: userRoles,
    // setData: setUserRoles,
    fetchData: fetchUserRoleData,
  } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/roles/getrolesforadmin`,
    method: "POST",
  });

  useEffect(() => {
    fetchData();
    fetchUserRoleData({ list: "listrolesusersmodules" });
  }, []);

  if (errorContent) return errorContent;

  //console.log("user.roles =>"); console.log(users[0].roles);
  const transformedUsers = users.map((user: any) => {
    return {
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      status: user.status,
      role: user.roles.length > 0 ? user.roles[0].role_name : "None",
      role_id: user.roles.length > 0 ? user.roles[0].id : "0",
      skills_abhs: user.skills_abhs,
      skills_abhs_mod2: user.skills_abhs_mod2,
      skills_pom_straps: user.skills_pom_straps
    };
  });

  const resetInputFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setRole("");
  };

  const handleUserSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const userData = {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      role_id: role,
    };

    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/users/add`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(userData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMessage("User added successfully!");
        setErrorMessage(null);

        //console.log("users    -------- ");console.log(users);
        //console.log("result.data ------- "); console.log(result.data);

        const updatedUsers = [...users, result.data];
        setUsers(updatedUsers);
      } else {
        setErrorMessage(result.errors[0].error || "Error adding user");
        setSuccessMessage(null);
      }
      resetInputFields();
    } catch (err) {
      setErrorMessage("Failed to add user, please try again.");
      setSuccessMessage(null);
    }
  };

  interface DataRow {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    role_id: string;
    status: number;
  }

  const populateFiledsForUpdate = (user: DataRow) => {
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setEmail(user.email);
    setPassword(""); // or your logic to reset password
    setRole(user.role_id);
    setIsUpdateActive(true);
  };

  /*const populateFiledsForUpdate = (user: {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    role_id: string;
  }) => {
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setEmail(user.email);
    setPassword("");
    setRole(user.role_id);
    setIsUpdateActive(true);
  };
*/
  const sendUpdatedUserData = async (userId: string) => {
    const userData = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password,
      //role_id: role,
    };

    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/users/update/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(userData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMessage("User updated successfully!");
        setErrorMessage(null);

        // Update the local users state
        setUsers((prevUsers: any) =>
          prevUsers.map((user: any) =>
            user.id === userId ? { ...user, ...result.data } : user
          )
        );
      } else {
        setErrorMessage(result.errors[0].error || "Error updating user");
        setSuccessMessage(null);
      }
    } catch (err) {
      setErrorMessage("Failed to update user, please try again.");
      setSuccessMessage(null);
    }
  };

  const handleUserUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    await sendUpdatedUserData(userId);
    setIsUpdateActive(false);
    resetInputFields();
  };

  /*const handleDeleteUser = async (userId: string, role_id: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      //alert(role_id + " " +  userId); 
      const userData = {
        user_id: userId,
        role_id: role_id
      };

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/users/delete`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Add this header
          },
          body: JSON.stringify(userData),
        }
      );

      if (response.ok) {
        setSuccessMessage("User deleted successfully!");
        setErrorMessage(null);

        setUsers((prevData: any) =>
          prevData.filter((user: any) => user.id !== userId)
        );
      } else {
        const result = await response.json();
        setErrorMessage(result.errors[0].error || "Error deleting user");
        setSuccessMessage(null);
      }
    } catch (err) {
      setErrorMessage("Failed to delete user, please try again.");
      setSuccessMessage(null);
    }
  };*/



    const handleStatusChange = async (userId: string, newStatus: number) => {
      //console.log(userId," ",newStatus);
      const confirm = window.confirm("Are you sure?");
      if(!confirm)return false;
      const userData = {
        status: newStatus,
      };
  
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No token found");
  
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/users/updatestatus/${userId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(userData),
          }
        );
  
        const result = await response.json();
  
        if (response.ok) {
          toast.info("User status is updated!");
          //setSuccessMessage("User status is updated successfully!");
          setErrorMessage(null);
  
          // Update the local users state
          setUsers((prevUsers: any) =>
            prevUsers.map((user: any) =>
              user.id === userId ? { ...user, ...result.data } : user
            )
          );
        } else {
          console.log(result);
          toast.warn("Error while updating user.");
          //setErrorMessage(result.errors[0].error || "Error updating user");
          setSuccessMessage(null);
        }
      } catch (err) {
        console.log(err);
        toast.warn("Failed to update user, please try again.");
        //setErrorMessage("Failed to update user, please try again.");
        setSuccessMessage(null);
      }
      /*try {
        
        const response = await fetch(`/api/user_status/${userId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status: newStatus }),
        });
    
        if (!response.ok) {
          throw new Error("Failed to update status");
        }
    
        alert(`User status updated to ${newStatus === 1 ? "Active" : "Inactive"}`);
        // Refresh or update the state as needed, e.g., fetch the updated user list
      } catch (error) {
        console.error("Error updating user status:", error);
        alert("An error occurred while updating user status.");
      }*/
    };

const handleSkillToggle = async (userId: string, field: "skills_abhs" | "skills_abhs_mod2" | "skills_pom_straps") => {

  const currentValue = users.find((u: User) => u.id === userId)?.[field] || 0;
  const flippedValue = currentValue === 1 ? 0 : 1;

  setUsers((prev: User[]) => prev.map((u: User) => u.id === userId ? { ...u, [field]: flippedValue } : u ));
  try {
    const res = await fetch(
      `${import.meta.env.VITE_API_URL}/admin/change_skill_status`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}`},
        body: JSON.stringify({ user_programdirector_id: userId, certification_id: field, status: flippedValue, }),
      }
    );

    const data = await res.json();

    if (!res.ok || !data.success) {
      setUsers((prev: User[]) => prev.map((u: User) => u.id === userId ? { ...u, [field]: currentValue } : u ));
      toast.error(data.message || "Failed to update skill status");
    } else {
      const fieldText = field.replace("skills_", "").replace(/_/g, " ").toUpperCase();
      const statusText = flippedValue === 1 ? "Enabled" : "Disabled";
      toast.info(`${fieldText} ${statusText}`);
    }
  } catch (err) {
    setUsers((prev: User[]) => prev.map((u: User) => u.id === userId ? { ...u, [field]: currentValue } : u ));
    toast.error("Failed to update skill status.");
  }
};

    
  const handleCancelUpdate = () => {
    setIsUpdateActive(false); // Exit edit mode
    setRole(''); // Reset form fields as needed
    setFirstName('');
    setLastName('');
    setEmail('');
    setPassword('');
  };

  return (
    <div className="adminUsers">
      <div className="form-container">
        <h2 style={{ fontSize: "24px" }}>{currentRole==1 ? 'Add/Edit User' : 'Users'}</h2>
        { currentRole==1 ?
        <EntityAddUpdateForm
          handleUserSubmit={
            isUpdateActive ? handleUserUpdate : handleUserSubmit
          }
          handleCancel={isUpdateActive ? handleCancelUpdate : undefined}
          isUpdateActive={isUpdateActive}
        >
          <TextInput
            placeholder="First name"
            value={firstName}
            onChange={(e) => {
              setErrorMessage(null);
              setSuccessMessage(null);
              setFirstName(e.target.value);
            }}
          />
          <TextInput
            placeholder="Last name"
            value={lastName}
            onChange={(e) => {
              setErrorMessage(null);
              setSuccessMessage(null);
              setLastName(e.target.value);
            }}
          />
          <TextInput
            placeholder="Email"
            value={email}
            type="email"
            onChange={(e) => {
              setErrorMessage(null);
              setSuccessMessage(null);
              setEmail(e.target.value);
            }}
          />
          <TextInput
            placeholder="Password"
            value={password}
            type="password"
            onChange={(e) => {
              setErrorMessage(null);
              setSuccessMessage(null);
              setPassword(e.target.value);
            }}
          />
          {isUpdateActive ? (
              // Show the role name as plain text in Edit mode
              <div style={{ width: '350px', paddingTop: '15px' }}>
                <label>Role: <br/>{userRoles.find((userRole: any) => userRole.id === role)?.role_name || "Role not found"}</label>                
              </div>
                ) : (
                  <SelectInput
                    value={role}
                    onChange={(e) => {
                      setErrorMessage(null);
                      setSuccessMessage(null);
                      setRole(e.target.value);
                    }}
                    name="role"
                    options={userRoles.map((userRole: any) => {
                      return { value: userRole.id, label: userRole.role_name };
                    })}
                  />
            )}
        </EntityAddUpdateForm> 
        : ''}
        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      </div>
      <div className="table-container">
        {isLoading ? (
          <ThreeLineCardSkeleton cardsCount={1} />
        ) : (
          <EntityTable
            headers={userHeaders}
            data={transformedUsers}
            onStatusChange={handleStatusChange}
            onEdit={populateFiledsForUpdate}
            setCurrentEntityId={setUserId}
            haveButton={false}
            activateBtn={currentRole==1 ? true : false}
            editBtn={currentRole==1 ? true : false}
  onSkillAbhsToggle={(id) => handleSkillToggle(id, "skills_abhs")}
  onSkillMod2Toggle={(id) => handleSkillToggle(id, "skills_abhs_mod2")}
  onSkillPomStrapToggle={(id) => handleSkillToggle(id, "skills_pom_straps")}
          />
        )}
      </div>
    </div>
  );
};

export default AdminUsers;